import { useL } from "@/lib/useL";
import React from "react";

// A flashcard that flips (question / answer) on click.
export function FlipCard({ q, a, flipped, onFlip, testid = "flip-card" }) {
  const L = useL();
  return (
    <button type="button" onClick={onFlip} data-testid={testid} aria-label={flipped ? L("Voir la question", "Show question") : L("Voir la réponse", "Show answer")}
      className="w-full min-h-[260px] [perspective:1200px] text-left">
      <div className={`relative w-full min-h-[260px] transition-transform duration-500 [transform-style:preserve-3d] ${flipped ? "[transform:rotateY(180deg)]" : ""}`}>
        <div className="absolute inset-0 border-2 border-[#002FA7] bg-background p-8 flex flex-col justify-center [backface-visibility:hidden]">
          <div className="font-mono uppercase tracking-[0.2em] text-[10px] text-[#002FA7] dark:text-blue-300 mb-3">Question</div>
          <div className="text-xl md:text-2xl font-bold leading-snug" data-testid={`${testid}-q`}>{q}</div>
          <div className="mt-6 text-xs text-muted-foreground">{L("Touchez la carte pour voir la réponse · glissez pour changer", "Tap the card to see the answer · swipe to change")}</div>
        </div>
        <div className="absolute inset-0 border-2 border-[#002FA7] bg-[#002FA7] text-white p-8 flex flex-col justify-center [backface-visibility:hidden] [transform:rotateY(180deg)]">
          <div className="font-mono uppercase tracking-[0.2em] text-[10px] opacity-80 mb-3">{L("Réponse", "Answer")}</div>
          <div className="text-lg md:text-xl leading-relaxed" data-testid={`${testid}-a`}>{a}</div>
        </div>
      </div>
    </button>
  );
}

export default FlipCard;
